export const DESIGN_URLS = [
  {
    label : 'R You Rogue',
    image : '/UI/zeus/gift-cards/with-grey-background/RYOUROGUE_bvojhf.png',
    value : '/UI/zeus/gift-cards/email-images/RYOUROGUE_ox0jeh.png',
  },
  {
    label : 'Rogue Fitness International',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_11_ifzgx3.png',
    value : '/UI/zeus/gift-cards/email-images/Product_Image_11_g4lhzx.png',
  },
  {
    label : 'Rogue Barbell Club',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_10_pwltyy.png',
    value : '/UI/zeus/gift-cards/email-images/Product_Image_10_eqhyuk.png',
  },
  {
    label : 'Rogue Wheel',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_5_qrau6j.png',
    value : '/UI/zeus/gift-cards/email-images/Product_Image_5_kyhsma.png',
  },
  {
    label : 'Don\'t Weaken',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_9_oapdta.png',
    value : '/UI/zeus/gift-cards/email-images/Updated%20Font%20Logos/Don_t_Weaken_pmwubc.png',
  },
  {
    label : 'Deadlift',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_4_cfcjrv.png',
    value : '/UI/zeus/gift-cards/email-images/Product_Image_4_kg22lh.png',
  },
  {
    label : 'Rogue Factory',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_3_weoxft.png',
    value : '/UI/zeus/gift-cards/email-images/Product_Image_3_lfwykj.png',
  },
  {
    label : 'Stones',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_1_fqytmu.png',
    value : '/UI/zeus/gift-cards/email-images/Product_Image_1_lvlybz.png',
  },
  {
    label : 'Knurling',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_2_menxay.png',
    value : '/UI/zeus/gift-cards/email-images/Product_Image_2_dwkx9x.png',
  },
  {
    label : 'Legend',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_6_gzwghd.png',
    value : '/UI/zeus/gift-cards/email-images/Updated%20Font%20Logos/Legend_o6o7qk.png',
  },
  {
    label : 'Work Hard',
    image : '/UI/zeus/gift-cards/with-grey-background/Card_Group_7_obopnw.png',
    value : '/UI/zeus/gift-cards/email-images/Updated%20Font%20Logos/Work_Hard_cxbuev.png',
  },
]
